import { IUser, userTabs } from '@/modules/user/models';
import { IClientContract } from '@/models/ClientContract';
import { IBond } from '@/models/Bond';
import {IRoleClassification} from '@/models/IRoleClassification';


export interface State {
    users: IUser[];
    localeTypes: any[];
    userBonds: IBond[];
    userSelected: IUser;
    bondSelected: IBond;
    showRegisterForm: boolean;
    currentTab: string;
    clientContracts: IClientContract[];
    groupedProfileFunctionalities: any[];
    roleClassifications: IRoleClassification[];
}

export const state = (): State => ({
    users: [],
    userBonds: [],
    localeTypes: [],
    showRegisterForm: false,
    currentTab: userTabs.tabs.listtab,
    groupedProfileFunctionalities: [],
    clientContracts: [],
    bondSelected: {
        bondtype: '',
        name: '',
        description: '',
        idbond: 0,
        idbondtype: 0,
        identifiernumber: '',
        isactive: true,
        value: '',
        idstorebpa: 0,
        valueBpa: '',
        selected: false,
    },
    userSelected: {
        id: 0,
        cdclicon: 0,
        idcountry: 0,
        idflag: 0,
        idvehicletype: 0,
        idroleclassification: 0,
        confirmationdateemail: undefined,
        isactive: true,
        dateofinclusion: undefined,
        email: '',
        shortname: '',
        fullusername: '',
        idusertype: 0,
        isemailconfirmed: false,
        office: '',
        password: '',
        phonenumber: '',
        functionalityrestrictions: [],
        profiles: [],
        bonds: [],
        usertype: { isactive: true, id: 0, usertypename: ''},
    },
    roleClassifications: [],
});
